/*
 * Perfume Product Info – size selector + add to cart
 *
 * Size selector swaps the selected variant inside the .ppi block: updates the
 * price, the hidden variant id the add-to-cart form posts, and the button state.
 *
 * Add to cart mirrors the homepage hero button (.fph-bottom__add-form in
 * fullscreen-product-hero.js): posts to /cart/add.js and opens the cart popup
 * instead of navigating to /cart. Only hijacked when the popup exists — it is
 * created by fullscreen-product-hero.js, which loads on the homepage only, so
 * the standalone product page keeps its normal form POST.
 *
 * Uses delegated listeners on document because the .ppi markup is also injected
 * into the homepage product panel via innerHTML (see fullscreen-product-hero.js),
 * where inline <script> tags never execute.
 */
(function () {
  if (window.__ppiSizeSelectorInstalled) return;
  window.__ppiSizeSelectorInstalled = true;

  function selectVariant(option) {
    var root = option.closest('.ppi');
    if (!root) return;

    root.querySelectorAll('[data-ppi-size-option]').forEach(function (el) {
      var selected = el === option;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var price = root.querySelector('[data-ppi-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    var input = root.querySelector('[data-ppi-variant-id]');
    if (input) input.value = option.dataset.variantId;

    // Leave the button alone mid-add; reset() re-derives its state afterwards.
    var button = root.querySelector('[data-ppi-add-to-cart]');
    if (button && button.dataset.ppiBusy !== 'true') {
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available
        ? button.dataset.addText || 'ADD TO CART'
        : button.dataset.soldOutText || 'SOLD OUT';
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var option = target.closest('[data-ppi-size-option]');
    if (!option) return;

    event.preventDefault();
    if (option.classList.contains('is-selected')) return;

    selectVariant(option);
  });

  /* Mirrors updateCartCount() in fullscreen-product-hero.js */
  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var headerCart = document.querySelector('.fph-header__cart');
        var label = (headerCart && headerCart.dataset.cartText) || 'CART';
        if (headerCart) headerCart.textContent = label + ' (' + cart.item_count + ')';

        var panelCart = document.querySelector('.fph-panel-header__cart');
        if (panelCart) panelCart.textContent = label + ' (' + cart.item_count + ')';

        var bubble = document.querySelector('[ref=cartBubbleCount]');
        if (bubble) bubble.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /*
   * Restore the button, but re-derive its state from whatever size is selected
   * now — the shopper may have switched to a sold-out size while the add was
   * still in flight.
   */
  function reset(button, text) {
    delete button.dataset.ppiBusy;
    button.classList.remove('ppi__add-to-cart--adding', 'ppi__add-to-cart--added');

    var root = button.closest('.ppi');
    var selected = root && root.querySelector('[data-ppi-size-option].is-selected');

    if (selected && selected.dataset.available !== 'true') {
      button.textContent = button.dataset.soldOutText || 'SOLD OUT';
      button.disabled = true;
      return;
    }

    button.textContent = text;
    button.disabled = false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.querySelector !== 'function') return;

    var button = form.querySelector('[data-ppi-add-to-cart]');
    if (!button || button.disabled) return;

    // No cart popup on this page (standalone product page) – let the form POST.
    if (!document.querySelector('.cart-popup')) return;

    event.preventDefault();

    var originalText = button.dataset.addText || button.textContent.trim();
    button.dataset.ppiBusy = 'true';
    button.textContent = 'ADDING...';
    button.disabled = true;
    button.classList.add('ppi__add-to-cart--adding');

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) {
          response
            .json()
            .then(function (d) {
              button.textContent = (d && d.description) || 'UNAVAILABLE';
            })
            .catch(function () {
              button.textContent = 'UNAVAILABLE';
            });
          setTimeout(function () {
            reset(button, originalText);
          }, 2200);
          return;
        }

        button.textContent = 'ADDED';
        button.classList.remove('ppi__add-to-cart--adding');
        button.classList.add('ppi__add-to-cart--added');
        updateCartCount();

        try {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('open-cart-popup'));
        } catch (ex) {}

        setTimeout(function () {
          reset(button, originalText);
        }, 2200);
      })
      .catch(function () {
        reset(button, originalText);
      });
  });
})();
